import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeImg from "../../Assets/home_img.png";
import Importance from "./Importance";
import Strength from "./Strength";
import Prevention from "./Prevention";
import underIcon from "../../Assets/under_icon.png";

function Hvac() {
  const [showUnderIcon, setShowUnderIcon] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const scrollThreshold = windowHeight * 0.3; // 화면 높이의 50%
      
      if (scrollPosition > scrollThreshold) {
        setShowUnderIcon(false);
      } else {
        setShowUnderIcon(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row className="align-items-center" style={{ minHeight: "80vh" }}>
            <Col md={6} className="home-text-section">
              <div className="home-header">
                <h1 className="home-title">
                HVAC <br className="tablet-line-break"/>유지관리 서비스
                </h1>
                <p className="home-description">
                HVAC 유지보수는 난방, 환기 및 <br className="mobile-line-break"/>공조 시스템의 효율적 운영을 위해 {" "}
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                <br className="tablet-br"></br>
                <br className="desktop-br"></br>
                <br className="large-br"></br>
                정기적으로 수행해야 하는 중요한 작업입니다. 
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                <br className="tablet-br"></br>
                <br className="desktop-br"></br>
                <br className="large-br"></br>
                이를 통해 시스템의 수명을 연장하고, <br className="mobile-line-break"/>에너지 효율성을 높이며,<br className="tablet-line-break"/> 고장을 예방할 수 있습니다. 
                </p>
              </div>
            </Col>
            <Col md={6} className="home-image-section">
              <div className="home-image-container">
                <img 
                  src={homeImg} 
                  alt="동진에어텍 홈 이미지" 
                  className="home-main-image"
                />
              </div>
            </Col>
          </Row>
          <div className={`under-icon-container ${showUnderIcon ? 'visible' : 'hidden'}`}>
            <img 
              src={underIcon} 
              alt="하단 아이콘" 
              className="under-icon"
            />
          </div>
        </Container>
      </Container>
      <Importance />
      <Strength />
      <Prevention />
    </section>
  );
}

export default Hvac;
